/**
 * GraphQL queries for SLA/Contract primitive
 *
 * 6 queries covering:
 * - Single SLA retrieval
 * - List with pagination
 * - Filter by entity
 * - Breached SLAs
 * - Warning SLAs
 * - Compliance report
 */

import { gql } from '@apollo/client';
import {
  SLA_FIELDS,
  SLA_CONNECTION_FIELDS,
  SLA_COMPLIANCE_REPORT_FIELDS,
} from './fragments';

/**
 * Get a single SLA by ID
 */
export const GET_SLA = gql`
  ${SLA_FIELDS}
  query GetSLA($tenantId: String!, $slaId: String!) {
    getSla(tenantId: $tenantId, slaId: $slaId) {
      ...SLAFields
    }
  }
`;

/**
 * List all SLAs for a tenant with pagination
 */
export const LIST_SLAS = gql`
  ${SLA_CONNECTION_FIELDS}
  query ListSLAs($tenantId: String!, $limit: Int, $cursor: String) {
    listSlas(tenantId: $tenantId, limit: $limit, cursor: $cursor) {
      ...SLAConnectionFields
    }
  }
`;

/**
 * Get SLAs by entity (task, workflow, document, etc.)
 */
export const GET_SLAS_BY_ENTITY = gql`
  ${SLA_FIELDS}
  query GetSLAsByEntity($tenantId: String!, $entityType: String!, $entityId: String!) {
    getSlasByEntity(tenantId: $tenantId, entityType: $entityType, entityId: $entityId) {
      ...SLAFields
    }
  }
`;

/**
 * Get all breached SLAs for a tenant
 * Critical for monitoring and alerting
 */
export const GET_BREACHED_SLAS = gql`
  ${SLA_FIELDS}
  query GetBreachedSLAs($tenantId: String!) {
    getBreachedSlas(tenantId: $tenantId) {
      ...SLAFields
    }
  }
`;

/**
 * Get all warning SLAs for a tenant
 * Proactive monitoring before breach occurs
 */
export const GET_WARNING_SLAS = gql`
  ${SLA_FIELDS}
  query GetWarningSLAs($tenantId: String!) {
    getWarningSlas(tenantId: $tenantId) {
      ...SLAFields
    }
  }
`;

/**
 * Get SLA compliance report for a tenant
 * Aggregate metrics for all SLAs
 */
export const GET_SLA_COMPLIANCE_REPORT = gql`
  ${SLA_COMPLIANCE_REPORT_FIELDS}
  query GetSLAComplianceReport($tenantId: String!) {
    getSlaComplianceReport(tenantId: $tenantId) {
      ...SLAComplianceReportFields
    }
  }
`;
